__turbopack_context__.v({
  "full-width-button": "reviews-modal-button-module-scss-module__797Mqa__full-width-button",
});
